var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleRight = function SvgAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.407 3 5.021 4.623a.516.516 0 0 1 0 .754L6.407 13",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAngleRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCjxwYXRoIGQ9Ik02LjQwNjk4IDNMMTEuNDI4NSA3LjYyMzA4QzExLjQ4IDcuNjcxNDIgMTEuNTIxMSA3LjcyOTgxIDExLjU0OTEgNy43OTQ2NEMxMS41NzcyIDcuODU5NDcgMTEuNTkxNyA3LjkyOTM2IDExLjU5MTcgOEMxMS41OTE3IDguMDcwNjQgMTEuNTc3MiA4LjE0MDU0IDExLjU0OTEgOC4yMDUzNkMxMS41MjExIDguMjcwMTkgMTEuNDggOC4zMjg1OCAxMS40Mjg1IDguMzc2OTJMNi40MDY5OCAxMyIgc3Ryb2tlPSIjMTQxNjFBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cgo8L3N2Zz4K";